import { XMarkIcon } from '@heroicons/react/24/outline';
import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { Button } from '../../../../components/ui/button';
import { formatCurrency } from '../../../../utils/fiat-currency.util';
import { ActivityModalType } from './TransactionListItem';

export type { ActivityModalType };

type Props = {
  activeModal: ActivityModalType;
  amount: string;
  currency: string;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const RefundActionModal: React.FC<Props> = ({
  activeModal,
  amount: amountRaw,
  currency,
  isPending,
  onClose,
  onConfirm
}) => {
  const amount = formatCurrency(Number(amountRaw), currency);

  return (
    <Dialog
      open
      onClose={isPending ? undefined : onClose}
      className="boder-red-300 rounded-xl border-1 p-0"
    >
      <DialogContent dividers className="min-w-[200px] max-w-[420px] p-0">
        <button
          onClick={onClose}
          disabled={isPending}
          className="ms-auto block disabled:opacity-40"
        >
          <XMarkIcon className="h-6 text-end" />
        </button>

        <div className="px-2 pb-3 text-gray-700">
          <h3 className="text-lg font-semibold leading-tight text-gray-900">
            {activeModal === 'requestRefund'
              ? 'Request Refund?'
              : 'Report Double Charge?'}
          </h3>

          <p className="mt-6 text-sm leading-relaxed text-gray-600">
            {activeModal === 'requestRefund'
              ? `You are about to request a full refund of ${amount}.`
              : `You are reporting a possible double charge of ${amount}.`}
          </p>

          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            {activeModal === 'requestRefund'
              ? 'The merchant will review it, and a refund transaction will appear in your history.'
              : 'The merchant will review it, and a record will appear in your history once resolved.'}
          </p>

          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            If there&apos;s no response, you can send a reminder after 24 hours.
          </p>

          <Button
            type="button"
            onClick={onConfirm}
            disabled={isPending}
            className="mt-5 w-full flex-1 rounded-full bg-[#5CB891] hover:bg-[#5CB891] disabled:opacity-60"
          >
            {isPending ? (
              <span className="inline-flex items-center gap-2">
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Processing...
              </span>
            ) : activeModal === 'requestRefund' ? (
              'Confirm Request'
            ) : (
              'Confirm Report'
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { RefundActionModal };
export default RefundActionModal;
